import { Mapper } from '@Features/utils/prepareSearchCriterias';
import {
  OrQuery,
  SearchCriteria,
  SearchItemValue,
} from '@Types/api/common/filters';

export const getOrQueries = (
  selectedFilters: Record<string, SearchItemValue>,
  orQueriesFields: string[],
  mapper: Mapper
): OrQuery[] | undefined => {
  const orQueries = Object.keys(selectedFilters)
    .filter((selectedFilterKey) => orQueriesFields.includes(selectedFilterKey))
    .reduce((acc, filterKey) => {
      const filterValue = selectedFilters[filterKey];

      const [resultKey, resultValue] = mapper(filterKey, filterValue);

      const processVariables: SearchCriteria[] = (
        resultValue as string[] | number[]
      ).map((value) => ({
        name: resultKey,
        value,
        operator: 'eq',
      }));

      if (processVariables.length) {
        const orQuery: OrQuery = {
          processVariables,
        };

        acc.push(orQuery);
      }

      return acc;
    }, [] as OrQuery[]);

  if (!orQueries.length) {
    return undefined;
  }

  return orQueries;
};
